<template>
  <v-layout
    row
    justify-center
    align-center
    class="authenticator-container"
  >
    <v-card
      min-width="460"
      class="px-4 py-4"
    >
      <v-card-title>
        <h2>Reset your password</h2>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-select
            v-if="!isCognitoType"
            v-model="appId"
            :items="applications"
            :rules="[v => !!v || 'Application client ID is required']"
            label="Application client ID "
            required
          />
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Email"
            required
          />
          <v-text-field
            v-if="codeSent"
            v-model="code"
            :rules="codeRules"
            label="Confirmation Code"
            required
          />
          <v-text-field
            v-if="codeSent"
            v-model="password"
            :append-icon="passwordVisible ? 'visibility' : 'visibility_off'"
            :rules="[passwordRules.required, passwordRules.min]"
            :type="passwordVisible ? 'text' : 'password'"
            name="password"
            label="New Password"
            hint="At least 8 characters"
            counter
            required
            @click:append="passwordVisible = !passwordVisible"
          />

          <v-layout
            row
            justify-space-between
            align-center
            class="mt-2"
          >
            <div>
              <router-link to="/login">
                Back to Sign In
              </router-link>
            </div>
            <e-button
              v-if="!codeSent"
              color="primary"
              text="Send Code"
              :loading="isSubmit"
              :disabled="!valid || isSubmit"
              @click="submit"
            />
            <e-button
              v-if="codeSent"
              color="primary"
              text="Reset password"
              :loading="isSubmit"
              :disabled="!valid || isSubmit"
              @click="verify"
            />
          </v-layout>
        </v-form>

        <v-alert
          v-if="error"
          type="error"
          :value="true"
          class="mt-2"
        >
          {{ error }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { forgotPassword, forgotPasswordSubmit } from '@/utils/auth';
import { Button } from '@/components/shared';

export default {
  name: 'SignIn',
  components: {
    'e-button': Button,
  },
  data() {
    return {
      valid: false,
      isSubmit: false,
      isCognitoType: false,
      passwordVisible: false,
      appId: '1',
      applications: [
        { text: 'Exporo AG', value: '1' },
        { text: 'Accontis', value: '4' },
      ],
      code: '',
      email: '',
      password: '',
      error: '',
      codeSent: false,
    };
  },
  computed: {
    emailRules() {
      return [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ];
    },
    passwordRules() {
      return {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      };
    },
    codeRules() {
      return [
        v => !!v || 'Code is required',
        v => (v && v.length === 6) || 'Code must be 6 digits',
      ];
    },
  },
  watch: {
    $route(to) {
      this.error = '';
      this.checkLoginType(to.query);
    },
  },
  created() {
    this.checkLoginType(this.$route.query);
  },
  methods: {
    async submit() {
      this.error = '';

      if (this.$refs.form.validate()) {
        const username = this.concatUsername(this.appId, this.email);

        try {
          this.isSubmit = true;
          await forgotPassword(username);
          this.isSubmit = false;
          this.codeSent = true;
        } catch (err) {
          this.setError(err);
          this.isSubmit = false;
        }
      }
    },
    async verify() {
      this.error = '';

      if (this.$refs.form.validate()) {
        const username = this.concatUsername(this.appId, this.email);
        try {
          this.isSubmit = true;
          await forgotPasswordSubmit(username, this.code, this.password);
          this.isSubmit = false;
        } catch (err) {
          this.setError(err);
          this.isSubmit = false;
        }
      }
    },
    concatUsername(appId, email) {
      if (this.isCognitoType) {
        return email;
      }

      return `${email}_app_${appId}`;
    },
    setError(err) {
      this.error = err.message || err;
    },
    checkLoginType(query) {
      const { type } = query;
      this.isCognitoType = type === 'cognito';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/authenticator/ResetPassword.vue